import React, { Component } from "react";
import { Button } from "reactstrap";

import SVGIcon from 'components/icon'
import InvalidEncodedContent from "./components/invalidEncoded";
import SignConfirmationForm from "./components/SignConfirmationForm";
import InitialTncModal from "./components/initialTncModal";
import ConfirmationCodeModal from "./components/confirmationCodeModal";
import IdentityVerificationModal from "./components/identityVerificationModal";
import LoadingOverlay from "components/loadingOverlay";

import EsigningHOC from "./actions";
import IQILogo from "assets/images/iqi_logo_and_name.png";

import "./index.css";

class Esigning extends Component {

  componentDidMount = () => {
    let encoded = this.props.match.params.encodedIdentity;
    let buff = new Buffer( encoded, "base64" );
    let text = buff.toString( "ascii" );
    let tempFormType = 2

    try {
      let tempArray = JSON.parse( text );

      this.props.onChangeHOC( tempArray.form_id, "formId" );
      this.props.onChangeHOC(
        {
          id: tempArray.form_id,
          confirmation_form_id: tempArray.form_contact_id,
        },
        "partyInfo"
      );
    } catch ( e ) {
      this.props.onChangeHOC( true, "showInvalidIdentityModal" );
    }

    if ( window.location.hash.indexOf( "confirmation" ) > -1 ){
      tempFormType = 1
    } if ( window.location.hash.indexOf( "appointment" ) > -1 ){
      tempFormType = 3
    } if ( window.location.hash.indexOf( "authorisation" ) > -1 ){
      tempFormType = 4
    }
    this.props.onChangeHOC( tempFormType, "formType" );
  };

  formTypeCheck = formTypeId => {
    switch ( formTypeId ) {
      case 1: return {
        complete_type_id: 3,
        reject_type_id: 4
      }

      case 2: return {
        complete_type_id: 5,
        reject_type_id: 6
      }

      case 3: return {
        complete_type_id: 7,
        reject_type_id: 8
      }

      case 4: return {
        complete_type_id: 9,
        reject_type_id: 10
      }
    
      default: 
        break;
    }
  }

  renderBodyContent = () => {
    const {
      htmlDivId,
      compDivId,
      signatureImage,
      confirmationContent,
      onChangeHOC,
      scrollToBottom,
      acknowledgementCheckbox,
      checkedAcknowledgeCheckbox,
      showSubmitFormSection,
      referenceId,

      formId,
      formType,
    } = this.props;

    const { id, status_id, refund_status_id, signee_type_id } = this.props.partyInfo;

    const dataToSubmit = {
      form_id: formId,
      form_contact_id: id,
    };

    let tempFormType = this.formTypeCheck( formType )
    let tempStatusId = formType === 2 ? refund_status_id : status_id;

    if ( tempStatusId === 2 || tempStatusId === 3 ) {
      return (
        <div className={ "text-center" }>
          <SVGIcon
            className={ "svg-icon mt-5" }
            style={{ fill: tempStatusId === 2 ? "#5eb85b" : "#d01c28" }}
            svgHref={ tempStatusId === 2 ? "icon-tick" : "icon-exclamation" }
          />
          <div className={ "mt-5" }>
            <h4>{ `Reference number: ${ referenceId }` }</h4>
            <h4>
              {
                tempStatusId === 2
                  ? `You have successfully signed this contract and your response has been recorded.`
                  : <>
                      You have chosen to decline signing this contract and your response has been recorded.
                      <br/>
                      Please communicate with the other party to proceed further.
                    </>
              }
            </h4>
            <a href={ "https://www.iqiglobal.com/" }>Take me to the IQI website.</a>
          </div>
        </div>
      );
    } else if( tempStatusId === 4 ) {
      return(
        <div className={ "text-center" }>
            <SVGIcon
              className={ "svg-icon mt-5" }
              style={{ fill: "#d01c28" }}
              svgHref={ "icon-expired" }
            />
            <div className={ "mt-5" }>
              <h4>{ `Reference number: ${ referenceId }` }</h4>
              <h4>
                Your link to this contract has expired.
                <br/>
                This may occur when the contract is requested to be physically signed on a printed copy.
                <br/>
                Please get in touch with your representative agent to proceed further.
              </h4>
              <a href={ "https://www.iqiglobal.com/" }>Take me to the IQI website.</a>
            </div>
          </div>
      )
    } else {
      return (
        <>
          <SignConfirmationForm
            htmlDivId={ htmlDivId }
            compDivId={ compDivId }
            formType={ formType }
            signee_type_id={ signee_type_id }
            scrollToBottom={ scrollToBottom }
            acknowledgementCheckbox={ acknowledgementCheckbox }
            checkedAcknowledgeCheckbox={ checkedAcknowledgeCheckbox }

            updateAcknowledgeCheckbox={ val => onChangeHOC( val, "acknowledgementCheckbox" ) }
            updateChecked={ val => onChangeHOC( val, "checkedAcknowledgeCheckbox" ) }
            onChangeScrollToBottom={ val => onChangeHOC( val, "scrollToBottom" ) }
            onChangeSignature={ val => onChangeHOC( val, "signatureImage" ) }
            onChangeCompanyStamp={ val => onChangeHOC( val, "companyStamp" ) }
            onChangeCompanyStampFilename={ val => onChangeHOC( val, "companyStampFilename" ) }
            content={ confirmationContent }
          />
          {
            showSubmitFormSection && (
            <div
              className={ "d-flex justify-content-center" }
              style={{ marginTop: 10 }}
            >
              <Button
                size={ "md" }
                disabled={ !signatureImage }
                color="primary"
                className={ "mr-2" }
                onClick={ () => {
                  if (acknowledgementCheckbox && !checkedAcknowledgeCheckbox) {
                    this.props.onChangeHOC( !scrollToBottom, "scrollToBottom" );
                  } else {
                    this.props.sendConfirmationCode({
                      ...dataToSubmit,
                      type_id: tempFormType.complete_type_id
                    })
                  }
                }}
              >
                Finish
              </Button>
              <Button
                size={ "md" }
                color="danger"
                className={ "mr-2" }
                onClick={ () =>
                  this.props.sendConfirmationCode({
                    ...dataToSubmit,
                    type_id: tempFormType.reject_type_id,
                    // if refund form then type_id is 6
                  })
                }
              >
                Decline
              </Button>
            </div>
          )}
        </>
      );
    }
  };

  render = () => {
    const {
      partyInfo,
      onLoad,
      onLoadConfirmation,
      submitTypeId,
      companyStamp,
      companyStampFilename,
      signatureImage,
      formType,
      showInitialTncModal,
      onChangeHOC,
      showIdentityVerification,
      showConfirmationCodeModal,
      showInvalidIdentityModal,
      formId,
      identifyVerification,
    } = this.props;

    const dataToSubmit = {
      form_id: formId,
      form_contact_id: partyInfo.id,
    };

    return (
      <div className={ "esigning-container" }>
        <div style={{ padding: "1rem" }}>
          <img src={ IQILogo } style={{ height: 40 }} />
        </div>
        { this.renderBodyContent() }
        <InitialTncModal
          open={ showInitialTncModal }
          onChangeHOC={ onChangeHOC }
          showLoading={ onLoad || onLoadConfirmation }
          onClickSubmit={ () => this.props.acceptTnc({
            ... dataToSubmit,
            form_type: formType
          })}
        />
        <InvalidEncodedContent open={ showInvalidIdentityModal } />
        <IdentityVerificationModal
          open={ showIdentityVerification }
          form_contact_id={ partyInfo.confirmation_form_id }
          showLoading={ onLoad || onLoadConfirmation }
          identifyVerification={ identifyVerification }
        />
        <ConfirmationCodeModal
          open={ showConfirmationCodeModal }
          submitTypeId={ submitTypeId }
          showLoading={ onLoad || onLoadConfirmation }
          mobileNum={ partyInfo.mobile_contact_number }
          onClickResend={ val => {
            this.props.sendConfirmationCode({
              ...dataToSubmit,
              type_id: val,
            });
          }}
          onClose={ () => this.props.onChangeHOC( false, "showConfirmationCodeModal" ) }
          onClickSubmit={ ( code, rejectReason, ownReason ) =>
            this.props.verifyConfirmationCode({
              ...dataToSubmit,
              type_id: submitTypeId,
              signature: signatureImage,
              company_stamp: companyStamp,
              company_stamp_file_name: companyStampFilename,
              confirmation_code: code,
              reject_option_id: parseInt( rejectReason ),
              reason: ownReason,
            })
          }
        />
        { ( onLoad || onLoadConfirmation ) && <LoadingOverlay /> }
      </div>
    );
  };
}

export default EsigningHOC( Esigning );
